import React from "react";
import { Navigate } from "react-router-dom";
import UserProfile from "../pages/Authentication/user-profile";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Error403 from "../pages/Authentication/Error403";
import Dashboard from "../pages/app-views/dashboard/index";
import DashboardPowerBI from "../pages/app-views/dashboard-power-bi/index";
import RelatoriosPowerBI from "../pages/app-views/relatorios-power-bi/index";
import EstruturaOrgnizacional from "../pages/app-views/estrutura-organizacional";
import CompaniesForm from "../pages/app-views/configuracoes/companies/form";
import CompaniesTable from "pages/app-views/configuracoes/companies/index";
import RelatoriosPowerBiForm from "../pages/app-views/configuracoes/relatorios-power-bi-config/form";
import RelatoriosPowerBiTable from "pages/app-views/configuracoes/relatorios-power-bi-config/index";
import ContasPowerBiForm from "../pages/app-views/configuracoes/relatorios-power-bi-config/form-contas";
import Indicadores from "../pages/app-views/indicadores";
import FormIndicadores from "../pages/app-views/indicadores/Form";
import PlanosDeAcao from "../pages/app-views/planos-de-acao/index";
import PlanosDeAcaoInactives from "../pages/app-views/planos-de-acao/indexInactives";
import PlanosDeAcaoForm from "../pages/app-views/planos-de-acao/form";
import Orcamentos from "../pages/app-views/orcamentos";
import Atas from "../pages/app-views/atas/form-atas/definicoes";
import Reunioes from "../pages/app-views/reunioes";
import ListaSetores from "../pages/app-views/configuracoes/lista-setores";
import PerfilUsuarios from "pages/app-views/configuracoes/perfil-usuarios";
import FormSetor from "../pages/app-views/configuracoes/form-setor";
import ListaUsuarios from "pages/app-views/cadastros-secundarios/usuario/lista-usuarios";
import FormUsuario from "pages/app-views/cadastros-secundarios/usuario/form-usuario";
import FormMeuPerfil from "pages/app-views/cadastros-secundarios/usuario/form-meu-perfil";
import NovaSenha from "pages/Authentication/nova-senha";
import FormPerfilUsuario from "../pages/app-views/configuracoes/form-perfil-usuario";
import FormAtas from "pages/app-views/atas/form-atas";
import PrintPdfEstrutura from "pages/app-views/estrutura-organizacional/components/PrintPdf";
import PrintPdfAta from "pages/app-views/atas/form-atas/Encaminhamentos/PrintPdf";
import PrintPdfPlanoAcao from "pages/app-views/planos-de-acao/PrintPdf";
import VisualizarIndicador from "pages/app-views/indicadores/Visualizar/index";
import LoginQuotes from "pages/app-views/configuracoes/login-quotes";
import MeetingsCalendar from "pages/app-views/agenda/index";
import FormMeeting from "pages/app-views/agenda/form";
import ViewingPermissions from "pages/app-views/configuracoes/viewing-permissions";
import UserRoles from "pages/app-views/cadastros-secundarios/user-roles";

const authProtectedRoutes = [
	// rotas do menu
	{ path: "/dashboard", component: <Dashboard /> },
	{ path: "/dashboard-power-bi/:id", component: <DashboardPowerBI /> },
	{ path: "/relatorios-power-bi", component: <RelatoriosPowerBI /> },
	{
		path: "/estrutura-organizacional",
		component: <EstruturaOrgnizacional />,
	},
	{ path: "/indicadores", component: <Indicadores /> },
	{ path: "/indicadores/form", component: <FormIndicadores /> },
	{ path: "/indicadores/form/:id", component: <FormIndicadores /> },
	{ path: "/indicadores/visualizar", component: <VisualizarIndicador /> },
	{ path: "/planos-de-acao", component: <PlanosDeAcao /> },
	{ path: "/planos-de-acao/inactives", component: <PlanosDeAcaoInactives /> },
	{ path: "/planos-de-acao/form", component: <PlanosDeAcaoForm /> },
	{ path: "/planos-de-acao/form/:id", component: <PlanosDeAcaoForm /> },
	{ path: "/planos-de-acao/inactives/form/:id", component: <PlanosDeAcaoForm /> },
	{ path: "/orcamentos", component: <Orcamentos /> },
	{ path: "/atas", component: <Atas /> },
	{ path: "/form-atas", component: <FormAtas /> },
	{ path: "/form-atas/:id", component: <FormAtas /> },
	{ path: "/reunioes", component: <Reunioes /> },

	{ path: "/agenda", component: <MeetingsCalendar /> },
	{ path: "/agenda/form", component: <FormMeeting /> },
	{ path: "/agenda/form/:id", component: <FormMeeting /> },

	// rotas do secundário (cadastros secundários)
	{ path: "/lista-usuarios", component: <ListaUsuarios /> },
	{ path: "/form-usuario", component: <FormUsuario /> },
	{ path: "/form-usuario/:id", component: <FormUsuario /> },
	{ path: "/form-perfil-usuario/:id", component: <FormPerfilUsuario /> },
	{ path: "/form-perfil-usuario", component: <FormPerfilUsuario /> },
	{ path: "/user-roles", component: <UserRoles /> },

	// rotas do secundário (configurações)
	{ path: "/empresas", component: <CompaniesTable /> },
	{ path: "/empresas/form", component: <CompaniesForm /> },
	{ path: "/empresas/form/:id", component: <CompaniesForm /> },
	{
		path: "/relatorios-power-bi-config",
		component: <RelatoriosPowerBiTable />,
	},
	{
		path: "/relatorios-power-bi-config/form",
		component: <RelatoriosPowerBiForm />,
	},
	{
		path: "/relatorios-power-bi-config/form/:id",
		component: <RelatoriosPowerBiForm />,
	},
	{
		path: "/relatorios-power-bi-config/form-contas",
		component: <ContasPowerBiForm />,
	},
	{
		path: "/relatorios-power-bi-config/form-contas/:id",
		component: <ContasPowerBiForm />,
	},
	{ path: "/lista-setores", component: <ListaSetores /> },
	{ path: "/perfil-usuarios", component: <PerfilUsuarios /> },
	{ path: "/meu-perfil", component: <FormMeuPerfil /> },
	{ path: "/form-setor", component: <FormSetor /> },
	{ path: "/form-setor/:id", component: <FormSetor /> },
	{ path: "/login-quotes", component: <LoginQuotes /> },
	{ path: "/viewing-permissions", component: <ViewingPermissions /> },

	//profile
	{ path: "/profile", component: <UserProfile /> },

	// this route should be at the end of all other routes
	// eslint-disable-next-line react/display-name
	{
		path: "/",
		exact: true,
		component: <Navigate to="/dashboard" />,
	},
];

const publicRoutes = [
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPwd /> },
	{ path: "/register", component: <Register /> },
	{ path: "/403", component: <Error403 /> },
];

const extraRoutes = [
	{ path: "/print/pdf/estrutura", component: <PrintPdfEstrutura /> },
	{ path: "/print/pdf/ata", component: <PrintPdfAta /> },
	{ path: "/print/pdf/plano-acao", component: <PrintPdfPlanoAcao /> },
];

export { authProtectedRoutes, publicRoutes, extraRoutes };
